import React, { useCallback, useMemo } from 'react'

import CreateCar from '../Create/CreateCar'
import CreateTransport from '../Create/CreateTransport'

import LineAngleRightIcon from 'components/Luxkit/Icons/line/LineAngleRightIcon'
import LineBusIcon from 'components/Luxkit/Icons/line/LineBusIcon'
import LineCarIcon from 'components/Luxkit/Icons/line/LineCarIcon'
import ListItem from 'components/Luxkit/List/ListItem'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'

interface Props {
  tripId: string
  defaultDate?: string
  sectionId?: string
}

function SelectTransportType(props: Props) {
  const { tripId, defaultDate } = props

  const openModal = useOpenModal()
  const { closeModal, goBack } = useModalCallbacks()

  const handleAddCar = useCallback(() => {
    openModal(CreateCar, { tripId, defaultDate })
  }, [openModal, tripId, defaultDate])

  const handleAddTransport = useCallback(() => {
    openModal(CreateTransport, {
      tripId,
      defaultDate,
    })
  }, [openModal, tripId, defaultDate])

  const listItemsData = useMemo(
    () => [
      {
        startIcon: <LineCarIcon />,
        endIcon: <LineAngleRightIcon />,
        key: 'addCarRental',
        title: 'Add a car rental',
        subtitle: 'Renting private vehicle',
        onClick: handleAddCar,
      },
      {
        startIcon: <LineBusIcon />,
        endIcon: <LineAngleRightIcon />,
        key: 'addTransport',
        title: 'Add transport',
        subtitle: 'Rail, bus, ferry',
        onClick: handleAddTransport,
      },
    ],
    [handleAddTransport, handleAddCar],
  )

  return (
    <>
      <ModalHeader
        title="Transport"
        onCloseButtonClick={closeModal}
        onBackButtonClick={goBack}
      />
      <ModalBody>
        <ModalContent>
          {listItemsData.map((item) => (
            <ListItem
              key={item.key}
              startIcon={item.startIcon}
              endIcon={item.endIcon}
              title={item.title}
              subtitle={item.subtitle}
              onClick={item.onClick}
            />
          ))}
        </ModalContent>
      </ModalBody>
    </>
  )
}

export default SelectTransportType
